// Presentation only. Hats use blank worn front/back pairs; kippot use a static rear view.
// Never use these portraits as supplier colour photos, order artwork or cart images.
export const capPresentation = {
  KR2020: {
    headwearType: 'classic_baseball',
    color: 'כחול נייבי',
    views: ['front', 'back'],
    front: 'kr2020-navy-blank-front-v2',
    back: 'kr2020-navy-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע KR2020 כחול נייבי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank navy KR2020 cap',
    altBackHe: 'הדמיית לבישה, גב כובע KR2020 כחול נייבי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank navy KR2020 cap',
  },
  KR2210: {
    headwearType: 'classic_baseball',
    color: 'טבעי',
    views: ['front', 'back'],
    front: 'kr2210-natural-blank-front-v2',
    back: 'kr2210-natural-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע KR2210 בצבע טבעי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank natural KR2210 cap',
    altBackHe: 'הדמיית לבישה, גב כובע KR2210 בצבע טבעי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank natural KR2210 cap',
  },
  KR2211: {
    headwearType: 'classic_baseball',
    color: 'צהוב',
    views: ['front', 'back'],
    front: 'kr2211-yellow-blank-front-v2',
    back: 'kr2211-yellow-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע רשת KR2211 צהוב עם חזית לבנה ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank yellow KR2211 with a white front panel',
    altBackHe: 'הדמיית לבישה, גב כובע רשת KR2211 צהוב ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank yellow KR2211 mesh cap',
  },
  KR2220: {
    headwearType: 'classic_baseball',
    color: 'שחור',
    views: ['front', 'back'],
    front: 'kr2220-black-blank-front-v2',
    back: 'kr2220-black-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע דרייפיט KR2220 שחור ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank black KR2220 dryfit cap',
    altBackHe: 'הדמיית לבישה, גב כובע דרייפיט KR2220 שחור ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank black KR2220 dryfit cap',
  },
  OM6110: {
    headwearType: 'classic_baseball',
    color: 'אפור',
    views: ['front', 'back'],
    front: 'om6110-grey-blank-front-v2',
    back: 'om6110-grey-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע OM6110 אפור עם מצחייה שחורה ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank grey OM6110 cap with a black brim',
    altBackHe: 'הדמיית לבישה, גב כובע OM6110 אפור ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank grey OM6110 cap',
  },
  OM6157: {
    headwearType: 'classic_baseball',
    color: 'שחור',
    views: ['front', 'back'],
    front: 'om6157-black-blank-front-v2',
    back: 'om6157-black-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע OM6157 שחור ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank black OM6157 cap',
    altBackHe: 'הדמיית לבישה, גב כובע OM6157 שחור ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank black OM6157 cap',
  },
  KR2350: {
    headwearType: 'bucket',
    color: 'טבעי',
    views: ['front', 'back'],
    front: 'kr2350-natural-blank-front-v2',
    back: 'kr2350-natural-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע פטרייה KR2350 בצבע טבעי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank natural KR2350 bucket hat',
    altBackHe: 'הדמיית לבישה, גב כובע פטרייה KR2350 בצבע טבעי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank natural KR2350 bucket hat',
  },
  OM6500: {
    headwearType: 'bucket',
    color: 'כחול נייבי',
    views: ['front', 'back'],
    front: 'om6500-navy-blank-front-v2',
    back: 'om6500-navy-blank-back-v2',
    altFrontHe: 'הדמיית לבישה, חזית כובע פטרייה OM6500 כחול נייבי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank navy OM6500 bucket hat',
    altBackHe: 'הדמיית לבישה, גב כובע פטרייה OM6500 כחול נייבי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank navy OM6500 bucket hat',
  },
  KR2382: {
    headwearType: 'kippot',
    color: 'חום',
    views: ['back'],
    back: 'kr2382-brown-blank-back',
    altBackHe: 'הדמיית לבישה, גב כיפת זמש KR2382 חומה ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank brown KR2382 suede kippah',
  },
  KR2381: {
    headwearType: 'kippot',
    color: 'לבן',
    views: ['back'],
    back: 'kr2381-white-blank-back',
    altBackHe: 'הדמיית לבישה, גב כיפת סאטן KR2381 לבנה ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank white KR2381 satin kippah',
  },
  KR2385: {
    headwearType: 'kippot',
    color: 'טבעי',
    views: ['back'],
    back: 'kr2385-natural-blank-back',
    altBackHe: 'הדמיית לבישה, גב כיפת פשתן KR2385 בצבע טבעי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank natural KR2385 linen kippah',
  },
  KPK: {
    headwearType: 'kippot',
    color: 'שחור',
    views: ['back'],
    back: 'kpk-black-blank-back',
    altBackHe: 'הדמיית לבישה, גב כיפת קטיפה KPK שחורה ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank black KPK velvet kippah',
  },
  KR2310: {
    headwearType: 'legionary',
    color: 'טבעי',
    views: ['front', 'back'],
    front: 'kr2310-natural-blank-front-v2',
    back: 'kr2310-natural-blank-back',
    altFrontHe: 'הדמיית לבישה, חזית כובע לגיונר KR2310 בצבע טבעי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank natural KR2310 legionnaire hat',
    altBackHe: 'הדמיית לבישה, גב כובע לגיונר KR2310 בצבע טבעי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank natural KR2310 legionnaire hat',
  },
  KR2353: {
    headwearType: 'legionary',
    color: 'טבעי',
    views: ['front', 'back'],
    front: 'kr2353-natural-blank-front-v2',
    back: 'kr2353-natural-blank-back',
    altFrontHe: 'הדמיית לבישה, חזית כובע לגיונר רחב שוליים KR2353 בצבע טבעי ללא מיתוג',
    altFrontEn: 'Wearing illustration, front of blank natural KR2353 wide-brim legionnaire hat',
    altBackHe: 'הדמיית לבישה, גב כובע לגיונר רחב שוליים KR2353 בצבע טבעי ללא מיתוג',
    altBackEn: 'Wearing illustration, back of blank natural KR2353 wide-brim legionnaire hat',
  },
};

// Printed illustrations belong to editorial surfaces, never product selection
// or a gallery of actual customer commissions.
export const capPrintExamples = {
  KR2210: { color: 'טבעי', image: 'kr2210-workshop-tiger', altHe: 'הדמיית כובע KR2210 עם הדפס טיגריס על שולחן עבודה בבית דפוס' },
  KR2020: { color: 'כחול נייבי', image: 'kr2020-workshop-sun', altHe: 'הדמיית כובע KR2020 עם הדפס שמש וגלים על שולחן עבודה לצד חולצות מקופלות' },
  KR2211: { color: 'צהוב', image: 'kr2211-workshop-wave', altHe: 'הדמיית כובעי רשת KR2211 צהובים עם הדפס גל בארגז בעמדת אריזה' },
};

export const capImageSrc = (name, width = 800) => `/cap-editorial/${name}-${width}.webp`;

export const capImageSrcSet = (name) => [400, 800, 1200]
  .map((width) => `${capImageSrc(name, width)} ${width}w`).join(', ');

// Fail closed if a presentation entry no longer matches the sold model/colour.
export function getCapPresentation(product) {
  const entry = capPresentation[product?.sku];
  if (!entry || product.headwearType !== entry.headwearType
    || !product.colors?.includes(entry.color)
    || !product.activePrintAreas?.includes('cap_front')) return null;
  return entry;
}

// The first permitted view is the primary image on every product surface.
export function getCapPresentationViews(product, language = 'he') {
  const entry = getCapPresentation(product);
  if (!entry) return [];
  const he = language === 'he';
  const views = {
    front: { key: 'front', label: he ? 'חזית' : 'Front', image: entry.front, alt: he ? entry.altFrontHe : entry.altFrontEn },
    back: { key: 'back', label: he ? 'גב' : 'Back', image: entry.back, alt: he ? entry.altBackHe : entry.altBackEn },
  };
  return entry.views.map((side) => views[side]);
}

export function getCapPrintExample(product) {
  const example = capPrintExamples[product?.sku];
  return getCapPresentation(product) && example && product.colors.includes(example.color) ? example : null;
}
